var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3333 0.666748H7.66659V2.00008H10.3333C11.4333 2.00008 12.3333 2.90008 12.3333 4.00008C12.3333 5.10008 11.4333 6.00008 10.3333 6.00008H7.66659V7.33341H10.3333C12.1733 7.33341 13.6666 5.84008 13.6666 4.00008C13.6666 2.16008 12.1733 0.666748 10.3333 0.666748ZM6.33325 6.00008H3.66659C2.56659 6.00008 1.66659 5.10008 1.66659 4.00008C1.66659 2.90008 2.56659 2.00008 3.66659 2.00008H6.33325V0.666748H3.66659C1.82659 0.666748 0.333252 2.16008 0.333252 4.00008C0.333252 5.84008 1.82659 7.33341 3.66659 7.33341H6.33325V6.00008ZM4.33325 3.33341H9.66659V4.66675H4.33325V3.33341Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/link-icon.8afefdc7a43699902dc0eb23ae12720c.svg";
export { ForwardRef as ReactComponent };